import React, { useState, useRef, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { CategoryEditForm } from "./CategoryEditAddForm";
import { Link } from "react-router-dom";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { useSubheader } from "../../../_metronic/layout";
import { useSnackbar } from "notistack";
import { fetchSingleCategory, updateCategory } from "../../../actions/categories/categories";


export function CategoryEdit({
  history,
  match: {
    params: { id, total },
  },
}) {
  const { enqueueSnackbar } = useSnackbar();


  const initCategory = {
    category_name: "",
    cart_order: "",

  };

  const { categoryForEdit } = useSelector(
    (state) => ({
      categoryForEdit: id
        ? state.categories && state.categories.categoryForEdit
        : undefined,
    }),
    shallowEqual
  );


  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");

  const dispatch = useDispatch()

  // get data
  useMemo(async () => {
    if (id === undefined) {
      return;
    }
    await dispatch(fetchSingleCategory(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);



  React.useEffect(() => {
    if (id) {
      suhbeader.setBreadcrumbs([{ pathname: '/category', title: 'Category' }, { pathname: '', title: 'Edit Category' }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const saveCategory = (values) => {
    if (id) {
      dispatch(updateCategory(values, id)).then(async (data) => {
        if (data && data.payload) {
          if (data && data.payload.error) {
            
            await enqueueSnackbar(data.payload.error, {
              variant: "error",
              autoHideDuration: 1500,
            });

          } else {
            
            await history.push(`/category`);
            await enqueueSnackbar("Category updated successfully", {
              variant: "success",
              autoHideDuration: 1500,
            });
          
          }
        }
      });
    }

  };

  const btnRef = useRef();
  const saveCategoryClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToCategoriesList = () => {
    history.push(`/category`);
  };

  return (
    <Card>
      {false && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToCategoriesList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            onClick={saveCategoryClick}>
            Save
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
          <li className='nav-item' onClick={() => setTab("basic")}>
            <Link
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle='tab'
              role='tab'
              aria-selected={(tab === "basic").toString()}>
              Category info
            </Link>
          </li>
        </ul>
        <div className='mt-5'>
          {tab === "basic" && (
            <CategoryEditForm
              category={categoryForEdit || initCategory}
              id={id}
              total={total}
              btnRef={btnRef}
              saveCategory={saveCategory}
            />
          )}

          {/* If you add new tab than add more */}
        </div>
      </CardBody>
      <hr />
      <CardHeader title={""} className='mt-2'>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToCategoriesList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            onClick={saveCategoryClick}>
            Save
          </button>
        </CardHeaderToolbar>
      </CardHeader>
    </Card>
  );
}
